import { useState, useEffect, useCallback, useRef } from 'react'
import { Observable } from 'rxjs'

export function useAsyncAction(action: (...args: any) => Observable<any>): [
  (...args: any) => void,
  any,
  Error,
  boolean
] {
  const [requestArgs, setRequestArgs] = useState<any>(null)
  const [response, setResponse] = useState<any>(null)
  const [error, setError] = useState<any>(null)
  const [loading, setLoading] = useState(false)

  // Keep a ref to the latest action so the effect can re-run only when
  // requestArgs change, without capturing a stale action closure.
  const actionRef = useRef(action)
  actionRef.current = action

  const updateArgs = useCallback((...args: any[]) => {
    setRequestArgs(args)
  }, [])

  useEffect(() => {
    if (requestArgs === null) {
      return
    }

    setLoading(true)
    const subscription$ = actionRef.current(...requestArgs).subscribe(
      (response: any) => {
        setResponse(response)
        setLoading(false)
      }, (error: Error) => {
        setError(error)
        setLoading(false)
      }
    )

    return function cleanup() {
      if (subscription$) {
        subscription$.unsubscribe()
      }
    }
  }, [requestArgs])

  return [updateArgs, response, error, loading]
}

export default useAsyncAction
